export const envelopeOpen =
  'M238.89 99.39a22.6 22.6 0 00-10.44-19.28L128 20 27.55 80.11A22.69 22.69 0 0017 99.39v113.43c0 12.47 10 22.68 22.2 22.68h177.6c12.21 0 22.2-10.21 22.2-22.68zM128 156.36L36.21 97.83 128 42.93l91.79 54.9z'
